<template>
  <router-view />
  <router-view v-slot="{ Component }" name="slideIn">
    <transition name="slide-in">
      <component :is="Component" />
    </transition>
  </router-view>
  <router-view name="dialog" />
</template>
